<template>
  <div ref="navRef" class="m-headingForT-nav">
    <div
      v-for="(item, index) in navItems"
      :key="index"
      v-ga-event="item.name"
      class="m-headingForT-nav__item"
      @click="scrollToSection(item.id)"
    >
      {{ item.name }}
    </div>
    <div v-ga-event="'Play Free CTA'" class="m-headingForT-nav__play-now" @click="Util.playFree()">Play Now</div>
  </div>
</template>

<script setup>
  import Util from '@/services/browser/Util'
  import { ref } from 'vue'
  const props = defineProps({
    navItems: {
      type: Array,
      required: true,
    },
  })

  const navRef = ref(null)

  const scrollToSection = (id) => {
    const element = document.getElementById(id)
    if (element) {
      window.scrollTo({
        top: element.getBoundingClientRect().top + window.scrollY - navRef.value.getBoundingClientRect().height * 1, // Adjust offset for sticky nav
        behavior: 'smooth',
      })
    }
  }
</script>

<style scoped lang="scss">
  @use '@/assets/scss/microsites/DemonSlayerCollab/variables.scss' as *;

  .m-headingForT-nav {
    position: sticky;
    top: 0;
    z-index: 20;
    height: 5.9vw;
    background: black;
    background: url('~@/assets/images/microsites/headingfortomorrow/_components/nav/nav-bg.png') no-repeat center center /
      100% auto;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8vw;
    margin: -0.45vw 0 -0.45vw;
  }

  .m-headingForT-nav__item {
    font-size: 1.45vw;
    cursor: pointer;
    color: #0f648d;
    transition: color 0.3s;
    text-shadow: 3px 3px 2px rgba(white, 0.3), 3px 3px 2px rgba(white, 0.3);
    text-transform: uppercase;
    position: relative;
    &:after {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 0vw;
      height: 6.2vw;
      transform: translate(-50%, -50%);
      content: '';
      background: url('~@/assets/images/microsites/headingfortomorrow/_components/nav/active-nav-item.png') no-repeat
        center center / auto 100%;
      opacity: 0;
      transition: opacity 0.3s, width 0.3s;
      z-index: -1;
    }
    &:hover,
    &.active {
      &:after {
        width: 13.5vw;
        opacity: 1;
      }
    }
  }

  .m-headingForT-nav__play-now {
    width: 10vw;
    height: 2.5vw;
    position: absolute;
    right: 4vw;
    top: 1.25vw;
    background: url('~@/assets/images/microsites/headingfortomorrow/_components/nav/btn.png') no-repeat center center /
      100% auto;
    font-size: 1.4vw;
    text-transform: uppercase;
    @extend %demonSlayerButton;
    &:hover {
      background-image: url('~@/assets/images/microsites/headingfortomorrow/_components/nav/btn-hover.png');
    }
  }

  .tablet {
    .m-headingForT-nav {
      height: 10.3vw;
      background: url('~@/assets/images/microsites/headingfortomorrow/_components/nav/nav-bg-tablet.png') no-repeat
        center center / 100% auto;
      gap: 7vw;
      padding-right: 22.5vw;
    }
    .m-headingForT-nav__item {
      font-size: 2.4vw;
      margin-bottom: 0.3vw;
      &:after {
        top: 37%;
        height: 11.6vw;
        transform: translate(-50%, -50%);
        background: url('~@/assets/images/microsites/headingfortomorrow/_components/nav/active-nav-item-tablet.png')
          no-repeat center center / auto 100%;
      }
      &:hover,
      &.active {
        &:after {
          width: 25.5vw;
        }
      }
    }
    .m-headingForT-nav__play-now {
      top: 2.2vw;
      right: 2vw;
      width: 20vw;
      height: 5vw;
      font-size: 3vw;
      @extend %demonSlayerButton;
    }
  }
  .mobile {
    .m-headingForT-nav {
      display: none;
    }
  }
</style>
